define('util/ExponentialIntervalGenerator',[], function () {
    'use strict';

    function ExponentialIntervalGenerator(maxInterval, _baselineInterval) {
        var baselineInterval = _baselineInterval || 0;
        var maxAdditionalInterval = maxInterval - baselineInterval;
        var failures = 0;

        this.fail = function () {
            failures++;
        };

        this.reset = function () {
            failures = 0;
        };

        this.getInterval = function () {
            /*
             The max interval is determined by the following equation:

             2^k - 1

             We then multiple it by 1000 to convert it to milliseconds.
             */
            var expInterval = (Math.pow(2, failures) - 1) * 1000;
            var generatedMaxInterval = Math.min(expInterval, maxAdditionalInterval);

            // Get a random interval amount so that we don't flood the server with reconnect
            // requests from every single user at the same time.
            var interval =  baselineInterval + Math.random() * generatedMaxInterval;
            return interval;
        };
    }

    return ExponentialIntervalGenerator;
});

